import React, { useEffect, useState } from 'react';
import { getAllBasicDetails } from '../service/RecruiterApi';
import moment from 'moment';
import { Info } from 'precise-ui/dist/es6/components/Icon/icons';
// import Loader from '../../StaticComponent/Loader';

function CandidateBasicDetails(props) {
    let primaryObject = {
        candidate_id: '',
        pan_no: '-',
        aadhar_no: '-',
        nationality: '-',
        marital_status: '-',
        blood_group: '-',
        house: '-',
        street: '-',
        area: '-',
        city: '-',
        country: '-',
        state: '-',
        pincode: '-',
        type: '-',
        full_name: '-',
        contact_no: '-',
        email_address: '-',
        address: '-',
        name: '-',
    };

    let familyObject = {
        candidate_id: '-',
        name: '-',
        dob: '-',
        is_employed: '-',
        organization: '-',
        designation: '-',
        compensation: '-',
        location: '-',
        nationality: '-',
        insured: '-',
        insure_type: '-',
        insured_with: '-',
        relation: '-',
        house_no: '-',
        road: '-',
        area: '-',
        city: '-',
        country: '-',
        state: '-',
        pincode: '-',
        type: '-',
        contact_no: '-',
        alt_contact_no: '-',
        have_passport: '-',
        passport_name: '-',
        number: '-',
        date_of_issue: '-',
        date_of_expiry: '-',
        place_of_issue: '-',
        ecnr: '-',
    };

    let educationObject = {
        institution: '-',
        year_of_passing: '-',
        year_of_joining: '-',
        percentage: '-',
        qualification: '-',
        name: '-',
        institute: '-',
    };

    let passportObject = {
        candidate_id: '-',
        havepassport: '-',
        name: '-',
        number: '-',
        date_of_issue: '-',
        date_of_expiry: '-',
        place_of_issue: '-',
        ecnr: '-',
        visa_number: '-',
        visa_type_id: '-',
        country: '-',
        visa_issue_date: '-',
        visa_expiry_date: '-',
        date_of_issue: '-',
    };

    const [primaryInfo, setPrimaryInfo] = useState(primaryObject);
    const [familyDetails, setFamilyDetails] = useState(familyObject);
    const [educationalInfo, setEducationalInfo] = useState(educationObject);
    const [passportDetails, setPassportDetails] = useState(passportObject);
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        loadData();
    }, []);

    let loadData = async () => {
        try {
            setIsLoading(false);
            let resp = await getAllBasicDetails({
                candidate_id: props.candidate_id,
                experience: props.experience,
            });
            setIsLoading(true);
            setPrimaryInfo(resp.data.ResponseData[0][0]);
            setFamilyDetails(resp.data.ResponseData[1][0]);

            setEducationalInfo(resp.data.ResponseData[2][0]);
            setPassportDetails(resp.data.ResponseData[3][0]);
        } catch (e) {}
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 mt-1">
                    <div className="card-body p-4">
                        <div className="accordion" id="accordionExample">
                            <div className="border-radi mb-3 body-bg border-0">
                                <h2 className="accordion-header recruit-timeline-spacing ps-3" id="headingOne">
                                    <div className="row align-items-center">
                                        <div className="col-md-5">
                                            <button
                                                className="recruit-accordion-button w-auto px-0 regular-text"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne"
                                                aria-expanded="false"
                                                aria-controls="collapseOne"
                                            >
                                                Primary Info
                                            </button>
                                        </div>
                                    </div>
                                </h2>
                                <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div className="accordion-body recruit-bg top-line">
                                        <div className="card-body p-4 pt-0">
                                            <div className="row">
                                                <label className="font-16 semibold-text mb-2">Personal Information</label>
                                                <div className="col-md-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Blood Group
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.blood_group == undefined ? '-' : primaryInfo.blood_group}
                                                    </p>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Nationality
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.nationality == undefined || primaryInfo?.nationality == null
                                                            ? '-'
                                                            : primaryInfo.nationality}
                                                    </p>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Marital Status
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.marital_status == undefined ? '-' : primaryInfo.marital_status}
                                                    </p>
                                                </div>

                                                <label className="font-16 semibold-text recruit-label-clr mb-3 mt-2 top-line pt-4">
                                                    Address Information
                                                </label>
                                                <label className="font-15 semibold-text recruit-label-clr mb-3 mt-0">Current Address</label>
                                                <div className="col-md-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        House / Building No.
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.house == undefined ? '-' : primaryInfo.house}
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Road / Street / Lane.
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.street == undefined ? '-' : primaryInfo.street}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Area / Locality / Sub Division
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.area == undefined ? '-' : primaryInfo.area}
                                                    </p>
                                                </div>
                                                <div className="col-md-6 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Town / city / District
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.city == undefined ? '-' : primaryInfo.city}
                                                    </p>
                                                </div>
                                                <div className="col-md-4  mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Country
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.country == undefined ? '-' : primaryInfo.country}
                                                    </p>
                                                </div>
                                                <div className="col-md-4  mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        State
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.state == undefined ? '-' : primaryInfo?.state}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Pincode
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.pincode == undefined ? '-' : primaryInfo.pincode}
                                                    </p>
                                                </div>

                                                <label className="font-15 semibold-text recruit-label-clr mb-4 mt-2 pt-4">
                                                    Permanent Address
                                                </label>
                                                <div className="col-md-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        House / Building No.
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.house == undefined ? '-' : primaryInfo.house}
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Road / Street / Lane.
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.street == undefined ? '-' : primaryInfo.street}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Area / Locality / Sub Division
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.area == undefined ? '-' : primaryInfo.area}
                                                    </p>
                                                </div>
                                                <div className="col-md-6 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Town / city / District
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.city == undefined ? '-' : primaryInfo.city}
                                                    </p>
                                                </div>
                                                <div className="col-md-4  mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Country
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.country == undefined ? '-' : primaryInfo.country}
                                                    </p>
                                                </div>
                                                <div className="col-md-4  mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        State
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.state == undefined ? '-' : 'Pondicherry'}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Pincode
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.pincode == undefined ? '-' : primaryInfo.pincode}
                                                    </p>
                                                </div>

                                                <label className="font-16 semibold-text mb-4 mt-5 top-line pt-4">
                                                    Emergency Information
                                                </label>
                                                <div className="col-md-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        First Name
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.full_name == undefined ? '-' : primaryInfo.full_name}
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Relationship
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.name == undefined ? '-' : primaryInfo.name}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Contact Number
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.contact_no == undefined ? '-' : primaryInfo.contact_no}
                                                    </p>
                                                </div>
                                                <div className="col-md-6 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Email Address
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.email_address == undefined ? '-' : primaryInfo.email_address}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4">
                                                    <label className="form-label semibold-text regular-text recruit-summary-label">
                                                        Address Information
                                                    </label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {primaryInfo?.address == undefined ? '-' : primaryInfo.address}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 mt-4"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="border-radi mb-3 body-bg border-0">
                                <h2 className="accordion-header recruit-timeline-spacing ps-3" id="headingTwo">
                                    <div className="row align-items-center">
                                        <div className="col-md-5">
                                            <button
                                                className="recruit-accordion-button w-auto px-0 collapsed regular-text"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseTwo"
                                                aria-expanded="false"
                                                aria-controls="collapseTwo"
                                            >
                                                Family Details
                                            </button>
                                        </div>
                                    </div>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div className="accordion-body recruit-bg top-line">
                                        <div className="row p-4 pt-0">
                                            <label className="font-16 semibold-text mb-2">Primary Info</label>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Relationship
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.relation == undefined ? '-' : familyDetails.relation}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">Name</label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.name == undefined ? '-' : familyDetails.name}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Date of Birth
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.dob == undefined ? '-' : moment(familyDetails.dob).format('ll')}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Place of Birth
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.location == undefined ? '-' : '-'}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Nationality
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.nationality == undefined ? '-' : familyDetails.nationality}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Insured
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.insured == undefined
                                                        ? '-'
                                                        : familyDetails.insured == true
                                                        ? 'Insured'
                                                        : 'Not insured'}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Type of Insurance
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.insure_type == undefined ||
                                                    familyDetails?.insure_type == null ||
                                                    familyDetails?.insure_type == ''
                                                        ? '-'
                                                        : familyDetails.insure_type}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Insured with
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.insured_with == undefined ||
                                                    familyDetails?.insured_with == '' ||
                                                    familyDetails?.insured_with == null
                                                        ? '-'
                                                        : familyDetails.insured_with}
                                                </p>
                                            </div>

                                            <label className="font-15 semibold-text recruit-label-clr mb-4 mt-2 pt-4">Address Info</label>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    House / Building No.
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.house_no == undefined ? '-' : familyDetails.house_no}
                                                </p>
                                            </div>
                                            <div className="col-md-6 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Road / Street / Lane.
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.road == undefined ? '-' : familyDetails.road}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Area / Locality / Sub Division
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.area == undefined ? '-' : familyDetails.area}
                                                </p>
                                            </div>
                                            <div className="col-md-6 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Town / city / District
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.city == undefined ? '-' : familyDetails.city}
                                                </p>
                                            </div>
                                            <div className="col-md-4  mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Country
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.country == undefined ? '-' : familyDetails.country}
                                                </p>
                                            </div>
                                            <div className="col-md-4  mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">State</label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.state == undefined ? '-' : familyDetails.state}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Pincode
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.pincode == undefined ? '-' : familyDetails.pincode}
                                                </p>
                                            </div>

                                            <label className="font-16 semibold-text mb-4 mt-5 top-line pt-4">Contact Info</label>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Contact No
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.contact_no == undefined ? '-' : familyDetails.contact_no}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Alternate Contact No
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {familyDetails?.alt_contact_no == undefined ? '-' : familyDetails.alt_contact_no}
                                                </p>
                                            </div>
                                            {/* <div className="col-md-4 mt-4">
                                                            <label className="form-label semibold-text regular-text recruit-summary-label">Contact Number</label>
                                                            <p className="recruit-label-clr regular-text mb-0">-</p>
                                                       </div> */}

                                            <div className="col-md-4 mt-4"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="border-radi mb-3 body-bg border-0">
                                <h2 className="accordion-header recruit-timeline-spacing ps-3" id="headingThree">
                                    <div className="row align-items-center">
                                        <div className="col-md-5">
                                            <button
                                                className="recruit-accordion-button w-auto px-0 collapsed regular-text"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseThree"
                                                aria-expanded="false"
                                                aria-controls="collapseThree"
                                            >
                                                Educational Details
                                            </button>
                                        </div>
                                    </div>
                                </h2>
                                <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div className="accordion-body recruit-bg top-line">
                                        <div className="row p-4 pt-0">
                                            <div className="col-md-6 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Educational Qualification
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {/* Post Graduation */}
                                                    {educationalInfo?.education == undefined ? '-' : educationalInfo.education}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Field of Study/Major
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {educationalInfo?.name == undefined ? '-' : educationalInfo.name}
                                                </p>
                                            </div>
                                            <div className="col-md-6 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Institute/School Name
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {educationalInfo?.institution == undefined ? '-' : educationalInfo.institution}
                                                </p>
                                            </div>
                                            <div className="col-md-4  mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Year of Passing
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {educationalInfo?.year_of_passing == undefined
                                                        ? '-'
                                                        : moment(educationalInfo.year_of_passing).format('YYYY')}
                                                </p>
                                            </div>
                                            <div className="col-md-4  mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Percentage
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {educationalInfo?.percentage == undefined ? '-' : educationalInfo.percentage}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="border-radi mb-3 body-bg border-0">
                                <h2 className="accordion-header recruit-timeline-spacing ps-3" id="headingThree">
                                    <div className="row align-items-center">
                                        <div className="col-md-5">
                                            <button
                                                className="recruit-accordion-button w-auto px-0 collapsed regular-text"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseFour"
                                                aria-expanded="false"
                                                aria-controls="collapseFour"
                                            >
                                                Passport and Visa Details
                                            </button>
                                        </div>
                                    </div>
                                </h2>
                                <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFour"
                                    data-bs-parent="#accordionExample"
                                >
                                    <div className="accordion-body recruit-bg top-line">
                                        <div className="row p-4 pt-0">
                                            <label className="font-16 semibold-text mb-2">Passport Details</label>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Name as in Passport
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.name == undefined ? '-' : passportDetails.name}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Passport Number
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.number == undefined ? '-' : passportDetails.number}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Expiry Date
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.date_of_expiry == undefined
                                                        ? '-'
                                                        : moment(passportDetails.date_of_expiry).format('ll')}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">ECNR</label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.ecnr == undefined ? '-' : passportDetails.ecnr}
                                                </p>
                                            </div>

                                            <label className="font-16 semibold-text recruit-label-clr mb-3 mt-2 top-line pt-4">
                                                Visa Details
                                            </label>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Visa Number
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.visa_number == undefined ? '-' : passportDetails.visa_number}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Visa Type
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.visa_type_id == undefined ? '-' : passportDetails.visa_type_id}
                                                </p>
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Expiry Date
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.visa_expiry_date == undefined
                                                        ? '-'
                                                        : moment(passportDetails.visa_expiry_date).format('ll')}
                                                </p>
                                            </div>
                                            <div className="col-md-4  mt-4">
                                                <label className="form-label semibold-text regular-text recruit-summary-label">
                                                    Country
                                                </label>
                                                <p className="recruit-label-clr regular-text mb-0">
                                                    {passportDetails?.country == undefined ? '-' : passportDetails.country}
                                                </p>
                                            </div>

                                            <div className="col-md-4 mt-4"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CandidateBasicDetails;
